import React, {useEffect} from "react";
import {InferProps} from "prop-types";
import {NoteFormView} from "./note-form.view";
import {StringParam, useQueryParam} from "use-query-params";
import {subjectView, useNote, usePrincipal} from "@betrue/front/services";
import {AnnotatedSubject, INote, isSuperUser} from "@betrue/shared/interfaces";
import {AdminZone} from "../admin-zone/admin-zone";

export const NoteFormPropsTypes = {}

export type NoteFormProps = InferProps<typeof NoteFormPropsTypes>

export interface NoteFormExtendedProps extends NoteFormProps {
  subject: string
  subjectId: string
}

export const NoteForm = (props: NoteFormExtendedProps) => {
  const [current] = usePrincipal()
  const currentSubject = subjectView()
  const [notes, {findNoteForSubject}] = useNote<INote[]>([])
  const [note, {addNote}] = useNote<INote>()
  const [subjectId,] = useQueryParam('subjectId', StringParam)
  const [subject,] = useQueryParam('subject', StringParam)

  useEffect(() => {
    if (subjectId && subject && current) {
      findNoteForSubject(AnnotatedSubject[subject], subjectId)
    }
  }, [subject, subjectId, current])

  useEffect(() => {
    if (subject && note && subjectId) {
      findNoteForSubject(AnnotatedSubject[subject],
        subjectId)
    }
  }, [note])

  const handleAddNote = (content: string) => {
    if (content) {
      const newNote: INote = {
        id: undefined,
        removed: false,
        content: content,
        subjectId,
        subject: AnnotatedSubject[subject],
      }
      addNote(newNote)
    }
  }

  if (!current || !subject || !subjectId || !isSuperUser(current) || !currentSubject) return (<></>)

  return (<AdminZone subject={currentSubject} principal={current}>
    <NoteFormView  {...props}
                   notes={notes}
                   onSubmitContent={handleAddNote}
                   current={current}/>
  </AdminZone>);
}


NoteForm.propTypes = NoteFormPropsTypes
